import React, { Fragment } from 'react'
import { Button, Form } from 'react-bootstrap'
import Loader from '../Main/Loader'
import useOtpVerification from '../../Hooks/Auth/useOtpVerification'

const OTPPage = () => {
    const [
        otp,
        isLoading,
        inputRefs,
        handleOtp,
        handleSubmit,

    ] = useOtpVerification();

    return (
        <Fragment>

            <div className="auth-background" style={{ height: "100vh" }}>
                <div className="overlay h-100" >
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-5 mt-5">
                                <div className="mt-5 card bg-white border-0 p-5">
                                    <h5 className='heading'>
                                        Forgot Password
                                    </h5>

                                    <p>
                                        Enter 4 - dight OTP
                                    </p>

                                    <Form onSubmit={handleSubmit} className='row'>
                                        {[...Array(4)].map((_, index) => (
                                            <div className="col-3" key={index}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="number"
                                                        className='text-center'
                                                        placeholder="0"
                                                        min="0"
                                                        max="9"
                                                        value={otp[index]}
                                                        onChange={(e) => handleOtp(e, index)}
                                                        onInput={(e) => handleOtp(e, index)}
                                                        ref={(el) => (inputRefs.current[index] = el)}
                                                    />
                                                </Form.Group>
                                            </div>
                                        ))}
                                        <div className='p-0'>
                                            <Button type='submit' className='btn btn-danger w-100 py-3'>
                                                {isLoading ? <Loader /> : "Submit"}
                                            </Button>
                                        </div>
                                    </Form>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default OTPPage